// jQuery
jQuery(function ($) {
  // $('.gnavBtn').on('click', function () {
  //   $(this).toggleClass('is-open');
  //   $('.gnav').toggleClass('is-open');
  //   var expanded = $(this).attr('aria-expanded') === 'true';
  //   $(this).attr('aria-expanded', !expanded);
  //   var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
  //   $(this).attr('aria-label', label);
  //   var hidden = $('.gnav').attr('aria-hidden') === 'true';
  //   $('.gnav').attr('aria-hidden', !hidden);
  // });
  // $('.gnav a').on('click', function () {
  //   $('.gnav').removeClass('is-open');
  //   $('.gnavBtn').removeClass('is-open');
  //   $('.gnavBtn').attr('aria-expanded', 'false');
  //   $('.gnavBtn').attr('aria-label', 'メニューを開く');
  //   $('.gnav').attr('aria-hidden', 'true');
  // });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  // var topBtn = $('.totop');

  // topBtn.click(function () {
  //   $('body,html').animate({
  //     scrollTop: 0
  //   }, 300, 'swing');
  //   return false;
  // });
});

// JavaScript


/*=====================================
recruit swiper 
=====================================*/
const recruitSwiper = new Swiper('.recruit-swiper', { // swiperの名前
  // 切り替えのモーション
  speed: 1000, // 表示切り替えのスピード
  effect: "slide", // 切り替えのmotion (※1)
  allowTouchMove: true, // スワイプで表示の切り替えを有効に

  // 最後→最初に戻るループ再生を有効に
  loop: true,

  // 自動スライドについて
  // autoplay: { 
  //   delay: 3000, // 何秒ごとにスライドを動かすか
  // },

  // 表示について
  centeredSlides: false, // 中央寄せにしない
  slidesPerView: "auto",
  spaceBetween: 30,

  // ナビゲーション
  navigation: {
    prevEl: ".swiper-button-prev", // 戻るボタンのclass
    nextEl: ".swiper-button-next" // 進むボタンのclass
  },
});

/*=====================================
top swiper 
=====================================*/
const topSwiper = new Swiper(".top-swiper", {
  // 切り替えのモーション
  speed: 1000, // 表示切り替えのスピード
  effect: "slide", // 切り替えのmotion (※1)
  allowTouchMove: true, // スワイプで表示の切り替えを有効に
  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  loop: true, //繰り返し指定
});

/*=====================================
sp swiper 
=====================================*/
const spSwiper = new Swiper(".sp-swiper", {
  // 切り替えのモーション
  speed: 1000, // 表示切り替えのスピード
  effect: "slide", // 切り替えのmotion (※1)
  allowTouchMove: true, // スワイプで表示の切り替えを有効に
  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  loop: true, //繰り返し指定
});

/*=====================================
service swiper 
=====================================*/
const serviceSwiper = new Swiper(".service-swiper", {
  // 切り替えのモーション
  speed: 1000, // 表示切り替えのスピード
  effect: "slide", // 切り替えのmotion (※1)
  allowTouchMove: true, // スワイプで表示の切り替えを有効に
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination", //必須の設定：ページネーションのclass指定
    type: "bullets",
    clickable: "clickable"
  },
  loop: true, //繰り返し指定
});